<template>
  <div v-if="$apollo.loading">Loading...</div>
  <q-page v-else padding>
    <h2 class="text-center">Account: {{account.companyName}}</h2>
    <h3>Details</h3>
    <q-checkbox :value="!!account.verifiedAt" label="Verified" @input="v => checkUpdateVerified(v)" />
    <div class="col q-gutter-md">
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">Company Name:</div>
        <div class="col-auto q-pl-md">
          {{account.companyName}}
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit v-model="account.companyName"
                        @save="v => updateAccount({companyName: v})"/>
        </div>
      </div>
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">ABN:</div>
        <div class="col-auto q-pl-md">
          {{account.ABNACN}}
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit :value="account.ABNACN"
                        @save="v => updateAccount({ABNACN: v})"/>
        </div>
      </div>
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">Contact Name:</div>
        <div class="col-auto q-pl-md">
          {{account.contactName}}
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit v-model="account.contactName"
                        @save="v => updateAccount({contactName: v})"/>
        </div>
      </div>
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">Account Email:</div>
        <div class="col-auto q-pl-md">
          {{account.email}}
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit v-model="account.email"
                        @save="v => updateAccount({email: v})"/>
        </div>
      </div>
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">Contact Phone:</div>
        <div class="col-auto q-pl-md">
          {{account.contactPhone}}
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit :value="account.contactPhone"
                        @save="v => updateAccount({contactPhone: v})"/>
        </div>
      </div>
      <div class="row">
        <div style="width: 8em; text-align: right;">Shipping Address:</div>
        <div class="col-auto q-pl-md">
          <span style="white-space: pre-wrap">{{account.shippingAddress}}</span>
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit :value="account.shippingAddress"
                        input-type="textarea"
                        @save="v => updateAccount({shippingAddress: v})"/>
        </div>
      </div>
      <div class="row">
        <div style="width: 8em; text-align: right;">Password:</div>
        <div class="col-auto q-pl-md">
          <q-btn size="sm" flat dense icon="edit" class="q-ml-sm" @click="editPassword">Edit Password</q-btn>
        </div>
      </div>
      <div class="column" v-if="currentAccount && currentAccount.roles.includes('assignRolesAccess')">
        <div class="row" v-if="currentAccount && currentAccount.roles.includes('assignRolesAccess')">
        <m-edit-item field="roles" type="array" graphqlType="Account" :id="account.id" />
        </div>
        <br/>
        <div>
          Available Roles: stockStoreAccess containerStoreAccess brandOrderAccess deleteSkuAccess deleteProductAccess
        </div>
      </div>
      <div class="row q-pt-lg" v-if="currentAccount && currentAccount.roles.includes('impersonateUsersRole')">
        <q-btn @click="loginAs">Log In As {{account.contactName}} from {{account.companyName}}</q-btn>
      </div>
      <div class="row q-pt-lg">
        <strong>Notes on Carts:</strong> You can use the carts section below to view and edit client's carts.  When you click the
        button next to a cart it will set your active stock or container cart to that cart and take you to the relevant
        cart page.  Here you can view the client's cart.  <strong>Note that your active stock or
        container cart is now set to this client's cart.  If you make changes it will update the client's cart.  You
        may find this to be useful in showing the client certain holds.
        <p class="text-primary">When you are done looking at or editing one of these carts, make sure you set your
        active stock or container cart back to one of your own carts!  Otherwise you will continue to add/remove products
        to that client's cart.</p></strong>
      </div>
      <div class="row">
        <div style="width: 8em; text-align: right;">Carts:</div>
        <div class="col-auto q-pl-md">
          <div v-for="cart in accountCarts" :key="cart.id">
            {{cart.name}} - {{cart.items.length}} items
            <q-btn dense flat size="sm" class="q-ma-xs" color="primary"
                   :label="`Set as active ${cart.cartType.toLowerCase().replace('cart', '')} cart and view`"
                   @click="changeActiveCart(cart)"/>
          </div>
        </div>
      </div>
    </div>
<!--    <h3>History</h3>-->
<!--    <h3>Behaviour</h3>-->
  </q-page>
</template>

<script>
import MPopupEdit from '../../components/ui/MPopupEdit'
import gql from 'graphql-tag'
import MEditItem from '../../components/ui/admin/MEditItem'
import adminNotifyError from '../../util/adminNotifyError'
import { properCase } from '../../util/string'
import { onLogin } from '../../apollo/auth'
export default {
  name: 'PageAdminAccount',
  components: { MEditItem, MPopupEdit },
  apollo: {
    account () {
      return {
        query: gql`
          query ($id: ID!) {
            account(id: $id) {
              id
              email
              companyName
              roles
              isAdmin
              ABNACN
              contactName
              contactPhone
              shippingAddress
              createdAt
              verifiedAt
            }
          }
      `,
        variables: {
          id: this.$route.params.id
        }
      }
    },
    accountCarts () {
      return {
        query: gql`
          query ($id: ID!) {
            accountCarts(accountId: $id) {
              id
              name
              cartType
              items {
                id
              }
            }
          }
      `,
        variables: {
          id: this.$route.params.id
        }
      }
    }
  },
  methods: {
    updateAccount (input) {
      this.$apollo.mutate({
        mutation: gql`
            mutation editAccount($id: ID!, $input: AccountInput!) {
              editAccount(id: $id, input: $input) {
                id,
                email,
                roles,
                companyName,
                isAdmin,
                ABNACN,
                contactName,
                contactPhone,
                shippingAddress,
                createdAt,
                verifiedAt
              }
            }
          `,
        variables: {
          id: this.$route.params.id,
          input
        }
      }).then(result => {
        // console.log(result)
      }).catch(err => {
        adminNotifyError(this.$q, 'Error Updating', err)
      })
    },
    updateVerified (val) {
      this.updateAccount({ verifiedAt: val })
    },
    checkUpdateVerified (val) {
      if (val) {
        this.updateVerified(new Date())
      } else {
        this.$q.dialog({
          title: 'Unverify Account',
          message: `Are you sure you want to unverify ${this.account.companyName}?`,
          cancel: true
        }).onOk(() => {
          this.updateVerified(null)
        })
      }
    },
    editPassword () {
      this.$q.dialog({
        title: 'Change Password',
        message: 'Enter a new password',
        prompt: {
          model: '',
          type: 'password',
          rules: "[ val => val && val.length > 7 || 'Please enter a password of at least 8 characters.' ]"
        },
        cancel: true
      }).onOk(newPass => {
        if (!newPass || newPass.length < 8) {
          this.$q.dialog({
            title: 'Safety first!',
            message: 'Please enter a password that\'s at least 8 characters long.',
            colour: 'red'
          })
          return
        }
        this.$q.dialog({
          title: 'Change Password',
          message: 'Repeat the new password',
          prompt: {
            model: '',
            type: 'password'
          },
          cancel: true
        }).onOk(async repeatedPass => {
          if (newPass !== repeatedPass) {
            this.$q.dialog({
              title: 'Password Not Changed!',
              message: 'Whoops, the passwords you typed didn\'t match, so we didn\'t change your password',
              colour: 'red'
            })
            return
          }
          await this.updateAccount({ password: newPass })
          this.$q.notify({
            message: 'Password was successfully changed',
            color: 'positive',
            icon: 'done'
          })
        })
      })
    },
    async changeActiveCart (cart) {
      if (this.activeCartId === cart.id) return // Don't update if it didn't change
      if (cart.cartType === 'StockCart') {
        await this.$store.dispatch('auth/updateCurrentAccount', { activeCartId: cart.id })
      } else if (cart.cartType === 'ContainerCart') {
        await this.$store.dispatch('auth/updateCurrentAccount', { activeContainerCartId: cart.id })
      } else if (cart.cartType === 'RetailCart') {
        await this.$store.dispatch('auth/updateCurrentAccount', { activeRetailCartId: cart.id })
      }
      await this.$store.dispatch('cart/init');
      this.$q.notify({
        message: `Active ${properCase(cart.cartType.replace('cart', ''))} cart changed to ${cart.name} (from account ${this.account.companyName || this.account.contactName})`,
        icon: 'done',
        color: 'grey'
      })
      if (cart.cartType === 'StockCart') this.$router.push(`/stock/cart`)
      else if (cart.cartType === 'ContainerCart') this.$router.push(`/container/cart`)
      else if (cart.cartType === 'RetailCart') this.$router.push(`/retail/cart`)
    },
    loginAs () {
      this.$apollo.mutate({
        mutation: gql`
            mutation loginAs($id: ID!) {
              loginAs(accountId: $id)
            }
          `,
        variables: {
          id: this.$route.params.id
        }
      }).then(async (result) => {
        const token = result.data.loginAs
        await onLogin(this.$apollo, token)
        await this.$store.dispatch('auth/init')
        await this.$store.dispatch('cart/init')
        await this.$store.dispatch('filters/fetchProductColours')
        this.$router.push('/account/details')
      }).catch(err => {
        adminNotifyError(this.$q, 'Error Updating', err)
      })
    }
  },
  computed: {
    currentAccount () {
      return this.$store.state.auth.currentAccount
    }
  },
  data () {
    return {
    }
  }
}
</script>
